<div class="content">
    <button mat-icon-button *ngFor="let red of rrss" [ngStyle]="{'background-color': red.color}" (click)="openLink($event)">
        <img [src]="red.icon" [ngStyle]="{'width': (red.name == 'facebook')? '15px':'30px' }">
    </button>
</div>